import { Component, forwardRef, Inject, Input, OnInit } from "@angular/core";
import { DateRange } from "@angular/material/datepicker";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Thing } from "../../model";
import { LayoutType } from "../shared/details-widget";
import { LocationSchemaPlanViewDisplayedValue } from "./location-schema-plan-viewer-details.component";
import { LocationSchemaPlanViewerGridElementDialogComponent } from "./location-schema-plan-viewer-grid-element-details-dialog.component";
import { LocationSchemaPlanViewThingData } from "./location-schema-plan-viewer.component";

@Component({
    selector: 'location-schema-plan-viewer-grid-element',
    template: require('./location-schema-plan-viewer-grid-element.component.html'),
    styles: [require('./location-schema-plan-viewer-grid-element.component.css')]
})
export class LocationSchemaPlanViewerGridElementComponent implements OnInit {

    @Input() isLinked: boolean;

    @Input() thingData: LocationSchemaPlanViewThingData;

    @Input() displayedValue: LocationSchemaPlanViewDisplayedValue;

    @Input() range: DateRange<moment.Moment>;

    @Input() detailsLayout: LayoutType;

    matIcon: string;
    imageUrl: string;
    thing: Thing;
    thingName: string;
    thingNameTooltip: string;

    constructor(
        @Inject(forwardRef(() => MatDialog)) private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.thing = this.thingData.thing;
        this.computeThingName();
        this.computeIcon();
    }

    private computeThingName(): void {
        if (!this.thing.name) {
            this.thingName = '-';
        } else if (this.thing.name.length > 30) {
            this.thingName = this.thing.name.substring(0, 30) + '...';
            this.thingNameTooltip = this.thing.name;
        } else {
            this.thingName = this.thing.name;
        }
    }

    private computeIcon(): void {
        const icon = this.thingData.thing.thingDefinition?.icon;
        if (icon) {
            if (icon.startsWith("https")) {
                this.imageUrl = icon;
            } else {
                this.matIcon = icon;
            }
        }
    }

    setLinkedThingsStyle(): void {
        const elContainers = Array.from(document.getElementsByClassName('grid-element-id-' + this.thingData.thing.id));
        elContainers?.forEach(container => {
            const labelContainer = container.getElementsByClassName('grid-element-label-container')[0];
            labelContainer?.setAttribute('class', 'd-flex grid-element-label-container-highlight');
        });
    }

    resetLinkedThingsStyle(): void {
        const elContainers = Array.from(document.getElementsByClassName('grid-element-id-' + this.thingData.thing.id));
        elContainers?.forEach(container => {
            const labelContainer = container.getElementsByClassName('grid-element-label-container-highlight')[0];
            labelContainer?.setAttribute('class', 'd-flex grid-element-label-container');
        });
    }

    openDetailsDialog(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = false;
        dialogConfig.minWidth = '25%';
        dialogConfig.data = { thingData: this.thingData, range: this.range, detailsLayout: this.detailsLayout };
        this.dialog.open(LocationSchemaPlanViewerGridElementDialogComponent, dialogConfig);
    }

}